var _ellipse, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 216,
    viewBox: "0 0 269 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.841,
    cy: 117.173,
    rx: 53.7148,
    ry: 53.729,
    fill: "#6DC872"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_175_908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.205 121.01L127.415 132.524L151.477 101.821",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.37243,
    height: 6.26937,
    rx: 1,
    transform: "matrix(0.98191 -0.189347 0.189251 0.981929 138.523 31.9349)",
    fill: "url(#paint0_linear_175_908)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.37271,
    height: 6.26903,
    rx: 1,
    transform: "matrix(0.873803 0.486281 -0.486085 0.873912 222.931 165.908)",
    fill: "url(#paint1_linear_175_908)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.37271,
    height: 6.26903,
    rx: 1,
    transform: "matrix(0.873803 0.486281 -0.486085 0.873912 72.1484 207.449)",
    fill: "url(#paint2_linear_175_908)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102.731,
    y: 49.5461,
    width: 2.47877,
    height: 2.89266,
    rx: 1,
    fill: "url(#paint3_linear_175_908)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.56527,
    height: 5.32698,
    rx: 1,
    transform: "matrix(0.890958 0.454086 -0.453895 0.891055 219.226 29.0793)",
    fill: "url(#paint4_linear_175_908)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 212.167,
    y: 52.4723,
    width: 2.47877,
    height: 2.89266,
    rx: 1,
    fill: "url(#paint5_linear_175_908)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 204.854,
    y: 161.142,
    width: 2.47877,
    height: 2.89266,
    rx: 1,
    fill: "url(#paint6_linear_175_908)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 224.702,
    y: 119.346,
    width: 2.47877,
    height: 2.89266,
    rx: 1,
    fill: "url(#paint7_linear_175_908)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 252.908,
    y: 81.7299,
    width: 2.47877,
    height: 2.89266,
    rx: 1,
    fill: "url(#paint8_linear_175_908)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 229.924,
    y: 148.603,
    width: 2.47877,
    height: 2.89266,
    rx: 1,
    fill: "url(#paint9_linear_175_908)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 178.882,
    y: 203.797,
    width: 2.47877,
    height: 2.89266,
    rx: 1,
    fill: "url(#paint10_linear_175_908)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.53959,
    height: 4.13029,
    rx: 1,
    transform: "matrix(0.922838 -0.385187 0.385014 0.922911 74.1484 39.1182)",
    fill: "url(#paint11_linear_175_908)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.53954,
    height: 4.13036,
    rx: 1,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 6.91699 186.693)",
    fill: "url(#paint12_linear_175_908)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 1.34046,
    height: 1.56421,
    rx: 0.670232,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 63.2529 63.9662)",
    fill: "url(#paint13_linear_175_908)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 1.34046,
    height: 1.56421,
    rx: 0.670232,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 200.098 72.3253)",
    fill: "url(#paint14_linear_175_908)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 1.34046,
    height: 1.56421,
    rx: 0.670232,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 255.462 96.358)",
    fill: "url(#paint15_linear_175_908)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 1.34046,
    height: 1.56421,
    rx: 0.670232,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 74.3408 161.525)",
    fill: "url(#paint16_linear_175_908)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 1.34046,
    height: 1.56421,
    rx: 0.670232,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 25.6455 14.8557)",
    fill: "url(#paint17_linear_175_908)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 2.54543,
    height: 2.97031,
    rx: 1,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 35.4639 115.914)",
    fill: "url(#paint18_linear_175_908)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 2.54543,
    height: 2.97031,
    rx: 1,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 38.749 153.705)",
    fill: "url(#paint19_linear_175_908)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 2.54543,
    height: 2.97031,
    rx: 1,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 113.802 190.147)",
    fill: "url(#paint20_linear_175_908)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 3.53954,
    height: 4.13036,
    rx: 1,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 156.986 13.811)",
    fill: "url(#paint21_linear_175_908)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 4.56001,
    height: 5.32116,
    rx: 1,
    transform: "matrix(0.954493 0.298234 -0.298091 0.954538 48.7002 49.3372)",
    fill: "url(#paint22_linear_175_908)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5611,
    height: 5.31988,
    rx: 1,
    transform: "matrix(-0.0462226 -0.998931 0.99893 -0.0462469 132.147 4.80225)",
    fill: "url(#paint23_linear_175_908)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 7.0324,
    height: 8.20449,
    rx: 1,
    transform: "matrix(-0.710445 0.703753 -0.703565 -0.710631 10.7686 93.8333)",
    fill: "url(#paint24_linear_175_908)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 7.03156,
    height: 8.20547,
    rx: 1,
    transform: "matrix(0.979084 -0.203456 0.203353 0.979106 260.219 195.945)",
    fill: "url(#paint25_linear_175_908)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_175_908",
    x: 108.705,
    y: 99.3213,
    width: 48.2715,
    height: 42.7024,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_175_908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_175_908",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_175_908",
    x1: 2.68621,
    y1: 0,
    x2: 2.68621,
    y2: 6.26937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_175_908",
    x1: 2.68635,
    y1: 0,
    x2: 2.68635,
    y2: 6.26903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_175_908",
    x1: 2.68635,
    y1: 0,
    x2: 2.68635,
    y2: 6.26903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_175_908",
    x1: 103.971,
    y1: 49.5461,
    x2: 103.971,
    y2: 52.4388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_175_908",
    x1: 2.28264,
    y1: 0,
    x2: 2.28264,
    y2: 5.32698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_175_908",
    x1: 213.406,
    y1: 52.4723,
    x2: 213.406,
    y2: 55.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_175_908",
    x1: 206.093,
    y1: 161.142,
    x2: 206.093,
    y2: 164.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_175_908",
    x1: 225.942,
    y1: 119.346,
    x2: 225.942,
    y2: 122.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_175_908",
    x1: 254.148,
    y1: 81.7299,
    x2: 254.148,
    y2: 84.6225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_175_908",
    x1: 231.163,
    y1: 148.603,
    x2: 231.163,
    y2: 151.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_175_908",
    x1: 180.121,
    y1: 203.797,
    x2: 180.121,
    y2: 206.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_175_908",
    x1: 1.7698,
    y1: 0,
    x2: 1.7698,
    y2: 4.13029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_175_908",
    x1: 1.76977,
    y1: 0,
    x2: 1.76977,
    y2: 4.13036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_175_908",
    x1: 0.670232,
    y1: 0,
    x2: 0.670232,
    y2: 1.56421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_175_908",
    x1: 0.670232,
    y1: 0,
    x2: 0.670232,
    y2: 1.56421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_175_908",
    x1: 0.670232,
    y1: 0,
    x2: 0.670232,
    y2: 1.56421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_175_908",
    x1: 0.670232,
    y1: 0,
    x2: 0.670232,
    y2: 1.56421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_175_908",
    x1: 0.670232,
    y1: 0,
    x2: 0.670232,
    y2: 1.56421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_175_908",
    x1: 1.27271,
    y1: 0,
    x2: 1.27271,
    y2: 2.97031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_175_908",
    x1: 1.27271,
    y1: 0,
    x2: 1.27271,
    y2: 2.97031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_175_908",
    x1: 1.27271,
    y1: 0,
    x2: 1.27271,
    y2: 2.97031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_175_908",
    x1: 1.76977,
    y1: 0,
    x2: 1.76977,
    y2: 4.13036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_175_908",
    x1: 2.28,
    y1: 0,
    x2: 2.28,
    y2: 5.32116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_175_908",
    x1: 2.28055,
    y1: 0,
    x2: 2.28055,
    y2: 5.31988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_175_908",
    x1: 3.5162,
    y1: 0,
    x2: 3.5162,
    y2: 8.20449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_175_908",
    x1: 3.51578,
    y1: 0,
    x2: 3.51578,
    y2: 8.20547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE67E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImg);
export default __webpack_public_path__ + "static/media/success_img.06cc2c524afee94deed97e3c32dcaa08.svg";
export { ForwardRef as ReactComponent };